<template>
<v-autocomplete ref="list" @focus="passEvent" :loading="loading" :value="value" :items="items" item-text="title" item-value="_id" label="نقش" v-bind="$attrs" v-on="$listeners" :rules="requiredRules" @input="v => $emit('input', v)"
  no-data-text="اطلاعاتی موجود نیست..."  prepend-inner-icon="mdi-account-details">
</v-autocomplete>
</template>

<script>
//
import myAxios from '../functions/myAxios'

export default {
  name: 'MyRoles',
  props: {
    value: {
      // type: String,
      required: true,
    },
    type: {},
    refs: {
      type: Boolean
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  methods: {
    async retrieveData() {
      //
      this.loading = true
      try {
        let res = await myAxios({
          method: 'GET',
          url: `/api/roles/names`,
        });
        if (res && res.data) {
          // console.log(res);
          let items = res.data.map(function(item) {
            return {
              _id: item._id,
              title: `${item.title}`,
            }
          })
          this.items = items
          this.loading = false
        }
      } catch (e) {
        console.error(e)
      }
    },
    passEvent() {
      if (this.items && this.items.length) {
        this.$emit('setDefaultValue', this.items[0])
      }
    },
  },
  async created() {
    await this.retrieveData()
  },
  mounted() {
    if (this.refs === true && this.$refs.list) {
      this.$refs.list.focus()
    }
  }
}
</script>
